import React from 'react';
import cx from 'classnames';
import styles from './index.module.scss.js';

const CryptoValue = ({
  currency,
  currencyImg,
  amount,
  v2,
  v3,
  className,
  style
}) => /* @__PURE__ */ React.createElement(
  "div",
  {
    className: cx(styles.box, className, {
      [styles.v2]: v2 && !v3,
      [styles.v3]: v3 && !v2
    }),
    style
  },
  /* @__PURE__ */ React.createElement(
    "img",
    {
      className: styles.crypto,
      src: currencyImg || `/crypto/${currency}.png`,
      alt: currency
    }
  ),
  /* @__PURE__ */ React.createElement("span", { className: styles.value }, amount),
  v3 && !v2 && /* @__PURE__ */ React.createElement("span", { className: styles.currency }, currency)
);
CryptoValue.displayName = "CryptoValue";

export { CryptoValue };
//# sourceMappingURL=index.js.map
